<app-dialog-header title="Add Skill to Profile" (closeClicked)="onCancelClick()">
</app-dialog-header>

<mat-dialog-content>
  <form>
    <mat-form-field #skillSelect>
      <mat-select [(value)]="skill" [formControl]="SkillFC">
        @for (skill of skills; track skill) {
        <mat-option [value]="skill">{{ skill.description }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="addSkillRule()" color="primary" mat-raised-button>Add</button>
</mat-dialog-actions>